let inMemoryToken = null;
let tempUser = null;
export const sessionService = {
  getToken: () => inMemoryToken,
  getUser: () => tempUser,
  setToken: (token) => {
    inMemoryToken = token;
  },
  setUser: (user) => {
    tempUser = user;
  },
  clearToken: () => {
    inMemoryToken = null;
  },
  clearSessionStorage: () => {
    inMemoryToken = null;
    tempUser = null;
  },
};



// WEBPACK FOOTER //
// ./src/services/session.js